import React from 'react'
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material'
import { useProviderSelect } from './hooks'

const PROVIDERS = ['openrouter', 'openai'] as const

export function ProviderSelect() {
  const { selectedProvider, setSelectedProvider } = useProviderSelect()

  return (
    <FormControl fullWidth size="small">
      <InputLabel id="provider-select-label">Provider</InputLabel>
      <Select
        labelId="provider-select-label"
        id="provider-select"
        value={selectedProvider}
        label="Provider"
        onChange={(e: SelectChangeEvent) => setSelectedProvider(e.target.value)}
      >
        {PROVIDERS.map((provider) => (
          <MenuItem key={provider} value={provider}>
            {provider}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
